import React, { useState } from 'react';
import { CurrentPlanProtag } from '../../../StaticPages/Pages/Skeleton/CurrentplanSkeleton';
import { useBilling } from '../../../../context/BillingContext';
import { useRazorpay } from '../../../../context/RazorpayContext';

const PaymentDetails = () => {
  const { currentPlan, loading, paymentMethods,refetchBilling,data } = useBilling()
  const { handleCreatePlan } = useRazorpay();
  const [isLoading, setIsLoading] = useState(false)
  // Mask card number helper
  const maskCardNumber = (last4 = "4232") => `•••• •••• •••• ${last4}` || 4232

  // Format expiry
  const formatExpiry = (month, year) => (month && year) &&`${month}/${year}`

  const handleRegeneratePaymentUrl = async (e) => {
    await handleCreatePlan(e, setIsLoading, 'generatePaymentUrl', null, refetchBilling)
  }


  return (
    <div className="card h-100 billing-card p-2">
      <div className="card-header h-auto bg-transparent border-0">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="plan-detail-title mb-1 card-title-custom">
              Payment Details
            </h5>
          </div>
          {loading?.currentPlan && (
            <CurrentPlanProtag />
          )
          //  : (
          //   currentPlan?.subscription?.status === 'active' &&
          //   <button className="btn plan-detail-card-btn" onClick={handleRegeneratePaymentUrl}>
          //     {isLoading ? (
          //       <>
          //         <span
          //           className="spinner-border spinner-border-sm me-2"
          //           role="status"
          //           aria-hidden="true"
          //         ></span>
          //         Loading...
          //       </>
          //     ) : <>Change Payment Method </>
          //     }
          //   </button>
          // )
          }
        </div>
      </div>

      {loading?.paymentMethods ? (
        <CurrentPlanProtag />
      ) : (
<div className="row g-4 mt-3 justify-content-center">

  {/* LEFT CARD UI */}
  <div className="rounded-4 p-4 position-relative card-ui col-md-5">

    {/* Card Icons */}
    <div className="mb-3 d-flex justify-content-between align-items-center">
      <h2 className="text-dark fs-5 fw-semibold py-1">
        {paymentMethods?.method}
      </h2>

      <span className="bg-success text-white small fw-medium px-3 py-1 rounded">
        {/* {paymentMethods?.status} */}Active
      </span>
    </div>

    {/* Card Number */}
    <h5 className="text-purple fw-bold fs-4 mb-3 d-flex align-items-center gap-2">
      {maskCardNumber(paymentMethods?.id)}

      {/* Validity Icon */}
      {paymentMethods?.valid ? (
        <i className="bi bi-check-circle-fill text-success"></i>
      ) : (
        <i className="bi bi-x-circle-fill text-danger"></i>
      )}
    </h5>

    {/* Card Footer Info */}
    <div className="d-flex justify-content-between text-muted small">
      <div>
        <div className="card-holder">Card Holder</div>
        <div className="card-holder-name mt-2">
          {paymentMethods?.name || "N/A"}
        </div>
      </div>
      <div className="text-end">
        <div className="card-holder">Valid Upto</div>
        <div className="card-holder-name mt-2">
        {paymentMethods?.vaild_up_to || "N/A"}
        </div>
      </div>
    </div>
  </div>

  {/* RIGHT DETAILS CARD */}
  <div className="col-md-5 rounded-4 p-4 position-relative card-ui">

    <h2 className="text-dark fs-5 fw-semibold py-1">Card Details</h2>

    <div className="d-flex justify-content-between border-bottom py-2">
      <span className="text-muted card-holder">Account Status</span>
      <span className='card-holder'>{paymentMethods?.account_status || "N/A"}</span>
    </div>

    <div className="d-flex justify-content-between border-bottom py-2">
      <span className="text-muted card-holder">Max Amount</span>
      <span className='card-holder'>{paymentMethods?.max_amount || "N/A"}</span>
    </div>

    <div className="d-flex justify-content-between border-bottom py-2">
      <span className="text-muted card-holder">Used At</span>
      <span className='card-holder'>{paymentMethods?.used_at || "N/A"}</span>
    </div>
    {paymentMethods?.failure_reason && (
    <div className="d-flex justify-content-between  py-2">
      <span className="text-muted card-holder">Failure Reason</span>
      <span className='card-holder text-danger'>{paymentMethods?.failure_reason || "None"}</span>
    </div>
    )}

  </div>
</div>

      )}
    </div>
  );
};

export default PaymentDetails;
